export default __webpack_public_path__ + "static/anna_bw-3c0ace94148f33163cadae076d983165.jpg";